import { NgModule } from '@angular/core';
import { DatePickerDirective } from './date-picker.directive';

@NgModule({
    imports: [DatePickerDirective],
    exports: [DatePickerDirective],
})
export class DatePickerModule {}
